import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { FaSortAlphaDownAlt } from "react-icons/fa";
import { FaSortAlphaDown } from "react-icons/fa";
export default function View() {
    const [allusers, setAllUsers] = useState([]);
    const [user, setUser] = useState([])
    const [UserName, setUserName] = useState("")

    const navigate = useNavigate();
    const edit = (user) => {
        navigate("/edituser", { state: { data: user } })
    }
    const deleteUser = (user) => {
        navigate("/delete", { state: { data: user } })
    }

    useEffect(() => {
        const getAllUser = async () => {
            const response = await axios.get("http://localhost:8080/allusers")
            setAllUsers(response.data)
        }
        getAllUser()
    }, [])

    const getAllUser = async () => {
        const response = await axios.get("http://localhost:8080/allusers")
        setAllUsers(response.data)
    }
    const search = async (e) => {
        e.preventDefault();
        if (UserName === "") {
            getAllUser()
        } else {
            try {
                const response = await axios.post("http://localhost:8080/searchuser", {
                    username: UserName,
                    email: UserName
                })
                setAllUsers(response.data)
            } catch {
                alert("User Dosen't exist")
            }
        }
    }

    const addUser = () => {
        window.location.href = "adduser"
    }
    const sortaz = () => {
        try {
            const response = axios.get("http://localhost:8080/sortaz")
            setAllUsers(response.data)
        } catch (e) {
            alert(e)
        }
        alert("a-z")
    }
    const sortza = () => {
        try {
            const response = axios.get("http://localhost:8080/sortza")
            setAllUsers(response.data)
        } catch (e) {
            alert(e)
        }
        alert("z-a")
    }

    return (
        <div class="relative overflow-x-auto shadow-md sm:rounded-lg m-2 p-2">
            <div class="flex flex-column sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center justify-between pb-4">
                <div className='flex justify-between gap-4'>
                    <button type="button" class="text-white bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 dark:focus:ring-blue-800 font-medium rounded-lg px-5 py-2.5 text-center me-2 mb-2" onClick={addUser}>Add User</button>
                    {/*         
                        next version           
                    <button type="button" class="text-white bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 dark:focus:ring-blue-800 font-medium rounded-lg text-xl px-5 py-2 text-center me-2 mb-2" onClick={sortaz}>
                        <FaSortAlphaDown /></button>
                    <button type="button" class="text-white bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 dark:focus:ring-blue-800 font-medium rounded-lg text-xl px-5 py-2 text-center me-2 mb-2" onClick={sortza}>
                        <FaSortAlphaDownAlt /></button> 
                    */}
                </div>
                <label for="table-search" class="sr-only">Search</label>
                <form class="relative" onSubmit={search}>
                    <div class="absolute inset-y-0 left-0 rtl:inset-r-0 rtl:right-0 flex items-center ps-3 pointer-events-none">
                        <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"></path></svg>
                    </div>
                    <input type="text" id="table-search" class="block p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Search for User" onChange={e => setUserName(e.target.value)} />
                </form>
            </div>
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                        <th scope="col" class="px-6 py-3">
                            Learn Sphere id
                        </th>
                        <th scope="col" class="px-6 py-3">
                            User Name
                        </th>
                        <th scope="col" class="px-6 py-3">
                            Email
                        </th>
                        <th scope="col" class="px-6 py-3">
                            Role
                        </th>
                        <th scope="col" class="px-6 py-3">
                            Action
                        </th>
                        <th scope="col" class="px-6 py-3">
                            Delete
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        allusers && allusers.map((user) => (
                            <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                <td class="px-6 py-4">
                                    {user.userid}
                                </td>
                                <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                    {user.username}
                                </th>
                                <td class="px-6 py-4">
                                    {user.email}
                                </td>
                                <td class="px-6 py-4">
                                    {user.role}
                                </td>
                                <td class="px-6 py-4">
                                    <button class="font-medium text-blue-600 dark:text-blue-500 hover:underline" onClick={() => edit(user)}>🖋️ Edit</button>
                                </td>
                                <td class="px-6 py-4">
                                    <button class="font-medium text-red-600 dark:text-red-500 hover:underline" onClick={() => deleteUser(user)}>🧹 Delete</button>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>

    )
}
